import { Component } from '@angular/core';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-admin-link',
  templateUrl: './admin-link.component.html',
  styleUrls: ['admin-link.component.scss'],
  standalone: false,
})
export class AdminLinkComponent {
  constructor() {}
  public userRoleUrl: string = environment.selectionToolUrl + 'admin/roles';
}
